export const SELECT_FIELD = 'SELECT_FIELD';
export const UNSELECT_FIELD = 'UNSELECT_FIELD';

export const ADD_FILTER = 'ADD_FILTER';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const CLEAR_FILTERS = 'CLEAR_FILTERS';
export const CHANGE_FILTER_FIELD = 'CHANGE_FILTER_FIELD';
export const CHANGE_FILTER_FIELD_NEW = 'CHANGE_FILTER_FIELD_NEW';
export const CHANGE_FILTER_OPERATOR = 'CHANGE_FILTER_OPERATOR';
export const CHANGE_FILTER_VALUE = 'CHANGE_FILTER_VALUE';
export const SET_INITAIL_STATE = 'SET_INITAIL_STATE';
export const UNSET_INITIAL_STATE = 'UNSET_INITIAL_STATE';

export const TRIGGER_GLOBAL_CLEAR = 'TRIGGER_GLOBAL_CLEAR';